import React from 'react';
import useStyle from './featureHighScore.style';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { PodiumBlock } from '../../../molecules/LeaderBoard/PodiumBlock';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { ImagesLots } from '../../../../types/Lots';
import { classNames } from '../../../../helpers/style/classNames';
import { UserPosition } from '../../../../types/leaderboard/leaderboard';
import { TableData } from 'components/organisms/Table/TableData';
import useIsMobile from 'helpers/responsive/useIsMobile';
import { ChallengeModal } from 'components/organisms/Challenge/ChallengeModal';
import { TableDataLineLeaderboard } from 'components/organisms/Table/TableData/TableDataLineLeaderboard';
import { EmptyDataMessage } from '../../../molecules/EmptyDataMessage';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { CURRENT_CHALLENGE_SEASON } from 'helpers/challenge/getChallengeInfos';

export interface FeatureHighScoreViewProps {
  users: Array<UserPosition>;
  img: ImagesLots;
  onChange: () => void;
  isOpen: boolean;
  onlyFirst?: boolean;
}

export const FeatureHighScoreView = ({
  users,
  img,
  onChange,
  isOpen,
  onlyFirst = false
}: FeatureHighScoreViewProps) => {
  const classes = useStyle();
  const isMobile = useIsMobile();
  const isMiniMobile = useMediaQuery('smallMobile');
  if (!users) return null;
  const winner = users.find(user => user.rank === 1);
  const second = users.find(user => user.rank === 2);
  const third = users.find(user => user.rank === 3);
  const others = users.filter(
    user => user.rank > 3 && Number(user.moyennegenerale) > 0
  );

  const generateTabLabels = () => {
    if (isMobile && !isMiniMobile) {
      return ['Rang', '', 'Profil', 'Note'];
    } else if (isMiniMobile) {
      return ['Rang', 'Profil', 'Note'];
    } else {
      return ['Rang', 'Profil', '', 'Ville', 'Note'];
    }
  };
  return (
    <>
      <EmptyDataMessage
        text={"Impossible d'établir un classement pour le moment 😕"}
        isVisible={!winner || !second || !third}
      />
      {winner && second && third && (
        <FeatureContainer
          buttonPosition={'bottomRight'}
          buttonWithText={
            <ChallengeModal
              variant={CURRENT_CHALLENGE_SEASON}
              buttonModal="leaderboard"
            />
          }
        >
          <div
            className={classNames([classes.root], {
              condition: isOpen,
              classe: classes.open
            })}
          >
            <div className={classes.podium}>
              <PodiumBlock user={second} lot={!onlyFirst ? img : null} />
              <PodiumBlock user={winner} lot={img} />
              <PodiumBlock user={third} lot={!onlyFirst ? img : null} />
            </div>

            <div className={classes.ranking}>
              <TableData noBackground={true} tabLabels={generateTabLabels()}>
                {others &&
                  others?.map((other, i) => (
                    <TableDataLineLeaderboard
                      key={i}
                      user={other}
                      isMobile={isMobile}
                    />
                  ))}
              </TableData>
            </div>
          </div>

          <div className={classes.more}>
            <ButtonWithText
              variant={'text'}
              content={isOpen ? 'Voir moins' : 'Voir plus'}
              icon={isOpen ? 'ArrowUp' : 'ArrowDown'}
              iconColor={'#959595'}
              iconSize="small"
              onClick={onChange}
            />
          </div>
        </FeatureContainer>
      )}
    </>
  );
};
